import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 92 70"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#181818",
  "fill-rule": "evenodd",
  d: "M84.37 33 56.478 3.37 59.39.631 91.747 35 59.39 69.37l-2.912-2.74L84.37 37H0v-4z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }